"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _LocaleContext = _interopRequireWildcard(require("../_utils/LocaleContext"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    videoButton: {
      cursor: 'pointer'
    }
  };
});
var LinkWrapper = function LinkWrapper(_ref) {
  var href = _ref.href,
    url = _ref.url,
    className = _ref.className,
    children = _ref.children,
    thumbnail = _ref.thumbnail,
    externalUrl = _ref.externalUrl,
    target = _ref.target,
    handleLinkClick = _ref.handleLinkClick;
  var classes = useStyles();
  var locale = (0, _react.useContext)(_LocaleContext.default);
  var linkUrl = (0, _LocaleContext.getLocaleLink)(url || href || '', locale);

  // Open Question: "noopener" or "noreferrer" for external URLs?
  var linkProps = (externalUrl ? {
    target: '_blank',
    rel: 'noopener'
  } : target && {
    target: target
  }) || {};
  var isVideo = linkUrl.endsWith('.mp4');
  if (isVideo) {
    var videoOnClick = function videoOnClick(event) {
      window.scrollTo(0, 0);
      window.aem.openVideoModal(event, {
        videoPath: linkUrl,
        posterImage: thumbnail || ''
      });
    };
    return __jsx("a", {
      className: (0, _clsx.default)(className, classes.videoButton),
      onClick: videoOnClick,
      role: "button"
    }, children);
  } else {
    return __jsx("a", (0, _extends2.default)({
      href: linkUrl
    }, linkProps, {
      className: className,
      onClick: handleLinkClick
    }), children);
  }
};
var _default = LinkWrapper;
exports.default = _default;